<template>
  <div>
    <TitlePage :title="$t('configurations')"></TitlePage>

    <v-layout wrap>

      <v-container fluid>
        <v-row>

          <v-col cols="12">
            <p>
              <strong>TUTORIAL</strong><br/>
              <a href="https://www.youtube.com/watch?v=vwP0RM7tEqU&ab_channel=BestWebTeacher" target="_blank">Come creare Paypal Client ID e Paypal Client Secret</a>
            </p>
          </v-col>

          <v-col cols="2">
            <v-subheader>Abilita PayPal</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-switch v-model="item.configurations.paypal_enabled" inset :label="$t('status')" dense></v-switch>
          </v-col>

          <v-col cols="2">
            <v-subheader>PayPal Client Id</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.paypal_client_id) ? '':$t('insertValue')" v-model="item.configurations.paypal_client_id" dense hide-details></v-text-field>
          </v-col>

          <v-col cols="2">
            <v-subheader>PayPal Client Secret</v-subheader>
          </v-col>
          <v-col cols="10">
            <v-text-field :label="(item.configurations.paypal_client_secret) ? '':$t('insertValue')" v-model="item.configurations.paypal_client_secret" dense hide-details type="password"></v-text-field>
          </v-col>

        </v-row>

      </v-container>

      <v-flex md12 class="d-flex">
        <v-divider class="marg-title"></v-divider>
      </v-flex>
      <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
        <v-btn elevation="2" color="" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t('back') }}
        </v-btn>
        <v-btn elevation="2" color="primary" class="ml-auto" @click="testSettings" style="margin-right: 5px">
          {{ $t('test') }}
        </v-btn>
        <v-btn elevation="2" color="primary" class="" @click="save" type="submit">
          {{ $t('save') }}
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
      </v-flex>

    </v-layout>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import QS from "qs";
import axios from "axios";

export default {
  name: "ConfigurationsCenter",
  components: {TitlePage},
  data() {
    return {
      item: {
        configurations: {
          paypal_client_id: '',
          paypal_client_secret: '',
          paypal_enabled: '',
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      'getUser': 'user/getUser',
    }),
  },
  async created(){
    if(!this.getUser.super_admin && this.getUser.center_id != this.$route.params.id){
      this.$router.push('/')
      return
    }
    this.setLoading(true);
    var fetchItem = await this.editItem(this.$route.params)
    if(fetchItem.result.configurations){
      this.item.configurations = fetchItem.result.configurations;
    }
    this.setLoading(false);
  },
  methods: {
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'editItem':'centers/edit',
      'updateItem':'centers/update',
    }),
    async testSettings(){
      await this.setLoading(true);
      const url = 'https://api.sandbox.paypal.com/v1/oauth2/token'
      const headers = {
        'Accept': 'application/json',
        'Accept-Language': 'en_US',
        'content-type': 'application/x-www-form-urlencoded',
      }
      const auth = {
        'username': this.item.configurations.paypal_client_id,
        'password': this.item.configurations.paypal_client_secret
      }
      try {
        const resp = await axios.post(url,
            QS.stringify({'grant_type': 'client_credentials'}),
            { headers, auth }
        );
        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: 'Configurazioni corrette, puoi procedere al salvataggio delle impostazioni'
        })
        await this.setLoading(false);
      } catch (e) {
        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: 'Configurazioni non valide, riprovare'
        })
        console.log(e)
        await this.setLoading(false);
      }

    },
    async save(){

      await this.setLoading(true);
      var result = await this.updateItem({...this.$route.params, item:this.item})
      await this.setLoading(false);

      if(result.success){

        this.setNotification({
          active: true,
          color: 'success',
          mode: 'multi-line',
          text: this.$t('updateSuccess')
        })

      }else {

        this.setNotification({
          active: true,
          color: 'error',
          mode: 'multi-line',
          text: result
        })

      }
    },

  },
  mounted() {

  },
}
</script>

<style scoped>

</style>